<app-accounts-layout [menuList]="menuList" ></app-accounts-layout>